import { get } from 'lodash';
import { formatUSD } from '@sparefoot/react-core/utils/format';

export default {
	cityLandingPage: (city, state, avgPrices) => {
		const overAllAvgPrice = get(avgPrices, 'overall.price');
		const avg5x5Price = get(avgPrices, '5x5.price');
		const avg5x10Price = get(avgPrices, '5x10.price');
		const questions = [
			{
				title: `What size storage unit should I rent in ${city}, ${state}?`,
				copy: `For storing the contents of a 1-bedroom home you'll need a 5'x10' or 10'x10' self storage unit. A home with 2 to 3 bedrooms will require a large storage unit size, either a 10'x15' or 10'x20'. If you need help finding the right storage unit in ${city}, ${state} give SelfStorage.com a call!`
			}
		];

		if (overAllAvgPrice) {
			questions.push({
				title: `How much is a monthly storage unit in ${city}?`,
				copy: `The average cost of a monthly storage unit in ${city} is ${formatUSD(overAllAvgPrice)},
				and you can compare storage prices to find the best storage unit for you on SelfStorage.com.`
			});
		}

		questions.push({
			title: `Are there 1st month free storage deals in ${city}?`,
			copy: `A lot of storage facilities offer a first month free promotion
				for new customers. To find storage units in ${city} with first month
				free and other storage deals you can search by zip code or city on SelfStorage.com.`
		});

		if (avg5x10Price) {
			questions.push({
				title: `How much is a 5x10 storage unit in ${city}?`,
				copy: `A 5' x 10' storage unit in ${city} costs about ${formatUSD(avg5x10Price)} per month.
				Browse SelfStorage.com to compare prices for all 5' x 10' storage units in ${city}.`
			});
		}

		if (avg5x5Price) {
			questions.push({
				title: `How much does a small storage unit cost in ${city}?`,
				copy: `Small storage units are typically 5' x 5' in size and cost about ${formatUSD(avg5x5Price)}
				per month in ${city}. Click to compare prices for all 5' x 5' storage units in ${city} on SelfStorage.com`
			});
		}
		questions.push({
			title: `Do I need climate controlled self storage in ${city}?`,
			copy: `Climate controlled storage is recommended for items that are vulnerable to extreme temperatures and humidity. If you're storing items like electronics, collectibles or personal items (books, clothing, and photos) in ${city}, then a storage unit with climate control will help protect your belongings.`
		}, {
			title: `What is the benefit of 24 hour access storage in ${city}?`,
			copy: 'With 24 hour access storage you\'ll have the ability to access your ' +
				'storage unit whenever you need to—even when the facility office is closed. ' +
				'This means you\'ll be able to access your belongings before or aftering working hours, ' +
				'and even on weekends and holidays.'
		});
		return questions;
	},
	vehicleLandingPage: {
		car: (city, state, avgPrices) => {
			const overAllAvgPrice = get(avgPrices, 'overall.price');
			const avg15FeetLongPrice = get(avgPrices, '15.price');
			const questions = [];

			if (overAllAvgPrice) {
				questions.push({
					title: `What is the average cost of car storage in ${city}?`,
					copy: `On average it costs about ${formatUSD(overAllAvgPrice)} per month to store a car in ${city}.
					You can compare car storage prices and sizes on SelfStorage.com.`
				});
			}

			questions.push({
				title: `How do I find the cheapest car storage in ${city}?`,
				copy: `A lot of storage facilities offer discounts for new customers.
				To find vehicle storage discounts in ${city} you can search by zip code on SelfStorage.com`
			});

			if (avg15FeetLongPrice) {
				questions.push({
					title: `How much does a 15' storage unit in ${city} cost?`,
					copy: `A 15' storage unit in ${city} is ${formatUSD(avg15FeetLongPrice)} per month.
					Although some compact cars might be able to squeeze into a 15' storage unit, a 20' is a better
					option since it is big enough for the majority of cars.`
				});
			}

			questions.push({
				title: `Is outdoor car storage cheaper in ${city}?`,
				copy: `Outdoor parking spots are typically the cheapest way to store a car because they don't offer the same
				level of protection as an indoor or enclosed storage unit. To compare car storage prices in ${city} you can
				search by zip code on SelfStorage.com.`
			});

			return questions;
		},
		rv: (city, state, avgPrices) => {
			const avg30FeetLongPrice = get(avgPrices, '30.price');
			const questions = [];

			if (avg30FeetLongPrice) {
				questions.push({
					title: `How much does RV storage cost in ${city}?`,
					copy: `On average it costs ${formatUSD(avg30FeetLongPrice)} per month to store an RV in ${city}.`
				});
			}

			questions.push({
				title: `Where do I store my RV long term in ${city}?`,
				copy: `The best option for long-term RV storage is at a storage facility, especially if you don't
				have a big enough garage to store it at home. To prevent any damage, indoor RV storage might be the
				best option. You can compare RV storage prices and browse discounts in ${city} on SelfStorage.com.`
			},
			{
				title: `Does indoor RV storage cost more per month in ${city}?`,
				copy: `Because indoor RV storage provides more protection, it usually does cost more per month
				in ${city} than an outdoor covered parking space.`
			},
			{
				title: `How do I find discounts for RV storage in ${city}?`,
				copy: `Many facilities do offer discounts for new customers, plus, you can find and compare all RV
				storage sizes and facilities on SelfStorage.com to find the best discount.`
			});

			return questions;
		},
		boat: (city, state, avgPrices) => {
			const avg25FeetLongPrice = get(avgPrices, '25.price');
			const questions = [];

			if (avg25FeetLongPrice) {
				questions.push({
					title: `What is the average cost of boat storage in ${city}?`,
					copy: `The average cost to storage a boat in ${city} is ${formatUSD(avg25FeetLongPrice)} per month.`
				});
			}

			questions.push({
				title: `How do I store my boat in ${city}?`,
				copy: `For easy access to your boat, it's best to store it in a marina slip or an outdoor boat parking space.
				If you need long term boat storage it is best to store it at a storage facility that offers indoor boat storage.
				Search by zip code to browse storage options in ${city} on SelfStorage.com.`
			},
			{
				title: `Does outdoor boat storage in ${city} provide enough protection?`,
				copy: `Outdoor boat storage is usually safe, but if you're storing your boat long term in ${city}, an indoor or
				enclosed storage unit will better prevent any damage. But, if you plan on using your boat frequently, a boat slip
				or parking space at a marina is the best option.`
			},
			{
				title: `Where do I find the cheapest boat storage in ${city}?`,
				copy: `A lot of storage facilities have discounts for new customers, like first month free and $1 first month rent.
				To compare discounts and prices for all storage options in ${city} zip code on SelfStorage.com.`
			});

			return questions;
		}
	},
	amenityLandingPage: {
		'climate-controlled': (city, state, avgPrices) => {
			const overAllAvgPrice = get(avgPrices, 'overall.price');
			const questions = [];

			if (overAllAvgPrice) {
				questions.push({
					title: `What's the average cost for a climate controlled storage unit in ${city}?`,
					copy: `On average a climate controlled storage unit costs about ${formatUSD(overAllAvgPrice)} per month in ${city}.`
				});
			}

			questions.push({
				title: `Should I get a climate controlled storage unit in ${city}?`,
				copy: `It's worth considering climate controlled storage if you live in an area with excessive humidity or heat and are storing sensitive items like clothes, mattresses, books or photos, and anything with sentimental value. You can compare prices for climate controlled storage units in ${city} on SelfStorage to find the best deal.`
			},
			{
				title: `How do I find the cheapest climate controlled storage in ${city}?`,
				copy: `Most storage facilities do offer discounts for new reservations, including units with climate control. You can find discounts in ${city} when you search by zip code or city on SelfStorage.com.`
			});

			return questions;
		},
		'24-hour-access': (city, state, avgPrices) => {
			const overAllAvgPrice = get(avgPrices, 'overall.price');
			const avg10x10Price = get(avgPrices, '10x10.price');
			const questions = [];

			if (overAllAvgPrice) {
				questions.push({
					title: `How much does 24 hour access storage cost in ${city}?`,
					copy: `On average a 24 hour access storage unit costs about ${formatUSD(overAllAvgPrice)} per month in ${city}. To compare all
					unit sizes and prices you can search by zip code on SelfStorage.com.`
				});
			}

			if (avg10x10Price) {
				questions.push({
					title: `What is the average cost of a 10x10 storage unit in ${city}?`,
					copy: `A 10' x 10' storage unit in ${city} 24 hour access costs about ${formatUSD(avg10x10Price)} per month. This can be slightly
					more than a unit without 24 hour access because of the added convenience of being able to access your belongings 24/7.`
				});
			}

			questions.push({
				title: `Are there any discounts for 24 hour storage units in ${city}?`,
				copy: `Many storage facilities offer promotional discounts for first time reservations, like first month free or $1 first month rent,
				and can browse all storage discounts in ${city} by searching for zip code SelfStorage.com.`
			});

			return questions;
		}
	}
};
